export default __webpack_public_path__ + "static/media/41.21d716f5.jpg";